import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from '../../../lib/utils';

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("flex flex-col w-full", className)}
      {...props}
    />
  )
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "flex items-center justify-between bg-gray-100 rounded-lg p-1",
        className
      )}
      {...props}
    />
  )
}

// eslint-disable-next-line no-lone-blocks
{/* 
  Tabs List based on Figma Design & scoped to be used in post July development (starting with Reports)
  TabsList is being used in some pages that were build prior to us
  engaging with a design agency and therefore at the time of writing this comment, `TabsList` cannot be 
  deprecated or edited in-place.
*/}
function SecondaryTabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "flex bg-white border-b border-gray-100 justify-start gap-1 bg-transparent shadow-none rounded-none",
        className
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "inline-flex items-center justify-center px-6 py-3 text-base",
        "text-gray-400 transition-all duration-200 whitespace-nowrap rounded-md",
        "font-semibold",
        "data-[state=active]:bg-white data-[state=active]:text-gray-900 data-[state=active]:shadow-sm",
        "hover:text-gray-700",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

// eslint-disable-next-line no-lone-blocks
{/* 
  Tabs Trigger based on Figma Design & scoped to be used in post July development (starting with Reports)
  TabsTrigger is being used in some pages that were build prior to us
  engaging with a design agency and therefore at the time of writing this comment, `TabsTrigger` cannot be 
  deprecated or edited in-place.
*/}
function SecondaryTabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "inline-flex items-center justify-center py-4 px-4 text-sm font-normal",
        "text-[#737373] transition-all whitespace-nowrap leading-5",
        "font-[family-name:var(--font-font-sans,Inter)]",
        "border-b-2 border-rounded-none border-transparent data-[state=active]:border-[#3551F3] data-[state=active]:text-[#0A0A0A] data-[state=active]:relative",
        "hover:text-gray-700",
        "disabled:pointer-events-none disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}


function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn(
        "mt-6 flex-1 outline-none data-[state=inactive]:hidden",
        className
      )}
      {...props}
    />
  )
}

export { Tabs, TabsList, SecondaryTabsList, TabsTrigger, SecondaryTabsTrigger, TabsContent }
